import React, { useEffect } from 'react';
import { Link, Switch, Route, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { BasicContent } from '../components';
import { Loading, Paginate } from '~/components';
import { loadPotencialPoluidores, removerPotencialPoluidor } from '~/store/modules/potencial_poluidor/action';
import Create from '../Create';
import Edit from '../Edit';
import Show from '../Show';

const List = () => {
  let location = useLocation();
  let modal = location.state && location.state.modal;
  const dispatch = useDispatch();
  const { potencial_poluidores, meta } = useSelector(
    ({ PotencialPoluidorReducer }) => PotencialPoluidorReducer
  );

  useEffect(() => {
    dispatch(loadPotencialPoluidores());
  }, [dispatch]);

  const breadcrumb = {
    label: 'Lista',
    to: '/potencial_poluidor',
    active: false,
  };

  const handleRemove = async (event) => {
    const id = event.target.value;
    Swal.fire({
      title: 'Remover?',
      text: 'Deseja Remover esse item?!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim!',
      cancelButtonText: 'Não'
    }).then(async (result) => {
      if (result.value) {
        try {
          await dispatch(removerPotencialPoluidor(id));
          await Swal.fire('Sucesso',
            'Removido com sucesso!',
            'success');
          dispatch(loadPotencialPoluidores());
        } catch (error) {
          await Swal.fire('Erro',
            'Erro ao Remover',
            'error');
        }
      }
    })
  };
  return (
    <>
      {modal && (
        <Switch>
          <Route children={<Create />} path="/potencial_poluidor/create" />
          <Route children={<Show />} exact path="/potencial_poluidor/:potencial_poluidor_id/detalhe" />
          <Route children={<Edit />} exact path="/potencial_poluidor/:potencial_poluidor_id/edit" />
        </Switch>
      )}
      <BasicContent breadcrumb={breadcrumb}>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Lista</h2>

            <div className="card-tools">
              <Link
                className="btn btn-success"
                to={{
                  pathname: '/potencial_poluidor/create',
                  state: { modal: true },
                }}
              >
                <i className="fa fa-plus" /> Novo
              </Link>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-sm table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th className="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {potencial_poluidores.data &&
                    potencial_poluidores.data.map((potencial_poluidor, index) => (
                      <tr key={index}>
                        <td>{potencial_poluidor.id}</td>
                        <td>{potencial_poluidor.nome}</td>
                        <td>
                          <div className="btn-group float-right">
                            <Link
                              className="btn btn-info"
                              to={{
                                pathname: `/potencial_poluidor/${potencial_poluidor.id}/detalhe`,
                                state: { modal: true },
                              }}
                            >
                              <FaEye /> Detalhes
                            </Link>
                            <Link
                              className="btn btn-default"
                              to={{
                                pathname: `/potencial_poluidor/${potencial_poluidor.id}/edit`,
                                state: { modal: true },
                              }}
                            >
                              <FaEdit /> Editar
                            </Link>
                            <button
                              className="btn btn-danger"
                              onClick={handleRemove}
                              value={potencial_poluidor.id}
                            >
                              <FaTrash /> Remover
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {!potencial_poluidores.data && <Loading />}
            </div>
          </div>
          <div className="card-footer clearfix">
            <Paginate load={loadPotencialPoluidores} meta={meta} />
          </div>
        </div>
      </BasicContent>
    </>
  );
};

export default List;
